const versionNum = '3.0.3'
// const backendURL = 'http://localhost:5003'
const backendURL = 'https://api-v3.ledgerdex.com'
const doGeoChecking = true
const multiLanguage = true
const linkToOldVersion = false

export const config = {
	VERSION: versionNum,
	supportedNetworks: {
		1: 'Main Ethereum Network',
		// 3: 'Ropsten Testnet',
		42: 'Kovan Testnet',
	},
	backendURL: backendURL,
	backendLogInURL: `${backendURL}/metamask-signin`,
	backendAPIURL: `${backendURL}/api`,
	// backendSRAHttpURLRoot: `${backendURL}/sra/`,
	backendLogInExtendURL: `${backendURL}/api/metamask-refresh`,
	backendLogInMessage: 'I agree with the terms and conditions of LedgerDex. Please sign me in.',
	doGeoChecking: doGeoChecking,
	linkToOldVersion: linkToOldVersion,
	backendGeoBlockCheckingURL: `${backendURL}/check-country-ban`,
	zeroExInstantScriptURL: 'https://instant.0x.org/v3/instant.js',
	statCounterTrackingCode: '<img src="//c.statcounter.com/11721213/0/468102c1/1/" alt="Web Analytics" >',
	localStorageKey: {
		login: 'userJWT',
		darkMode: 'DARK_MODE',
		locale: 'locale',
		geoBanBypass: 'geoBanBypass',
	},
	defaultRedirect: {
		logout: 'Logout',
		publicHome: 'PublicHome',
		appHome: 'AppHome',
		WalletNotConnected: 'Logout',
		chainChange: 'Logout',
		accountChange: 'Logout',
	},
	cacheTime: {
		network: 1 * 60 * 1000, // miliseconds
		tokenInfo: 1 * 60 * 1000,
		account: 1 * 60 * 1000,
		relayerInfo: 1 * 60 * 1000,
		gasPrice: 2 * 60 * 1000, // miliseconds
	},
	logOutWarningTime: 5, // in minutes
	numOrdersToFetchFromRelayers: 20,
	minOrderAvailableAmount: 0.0000001,
	numOpenOrdersToShowForBidsAndAsks: 8,
	autoOrderStateCheckingTimeInterval: 10 * 1000,
	network: {
		1: {
			id: 1,
			name: 'Main Ethereum Network',
			rpc: 'https://mainnet.infura.io/v3/2dba9736d8f64eb6b639fe233fea428c',
			// rpc: 'https://cloudflare-eth.com',
			txURL: 'https://etherscan.io/tx/',
			accountURL: 'https://etherscan.io/address/',
			tokenURL: 'https://etherscan.io/token/',
			etherscanApiURL: 'https://api.etherscan.io/',
			feeRecipientAddress: '0x4524baa98f9a3b9dec57caae7633936ef96bd708',
			backendSRAHttpURL: `${backendURL}/sra/1/v3/`,
			meshSRAHttpURL: 'https://api.0x.org/sra/',
			gasPriceCheckerURL: {
				ethgasstation: 'https://ethgasstation.info/json/ethgasAPI.json',
				etherscan: 'https://api.etherscan.io/api?module=gastracker&action=gasoracle'
			},
			// ownRelayer: {
			// 	name: relayerName,
			// 	apiURL: `${backendURL}/sra/1/v2/`,
			// },
			relayers: [
				{
					name: 'LedgerDex',
					apiURL: `${backendURL}/sra/1/v3/`,
					orderBookPriority: 10,
				},
				// {
				// 	name: 'Radar Relay',
				// 	apiURL: 'https://api-v3.radarrelay.com/0x/v3/',
				// 	// wsURL: 'wss://ws.radarrelay.com/0x/v2'
				// },
				{
					name: 'Mesh',
					apiURL: 'https://api.0x.org/sra/',
					// wsURL: 'wss://ws.radarrelay.com/0x/v2',
					orderBookPriority: 100,
				},
			],
			// popularTradingPairs: popularTradingPairs[1]
		},
		3: {
			id: 3,
			name: 'Ropsten Testnet',
			rpc: 'https://ropsten.infura.io/v3/2dba9736d8f64eb6b639fe233fea428c',
			txURL: 'https://ropsten.etherscan.io/tx/',
			accountURL: 'https://ropsten.etherscan.io/address/',
			tokenURL: 'https://ropsten.etherscan.io/token/',
			etherscanApiURL: 'https://api-ropsten.etherscan.io/',
			feeRecipientAddress: '0x4524baa98f9a3b9dec57caae7633936ef96bd708',
			backendSRAHttpURL: `${backendURL}/sra/3/v3/`,
			meshSRAHttpURL: 'https://ropsten.api.0x.org/sra/',
			gasPriceCheckerURL: {
				etherscan: 'https://api-ropsten.etherscan.io/api?module=gastracker&action=gasoracle'
			},
			// ownRelayer: {
			// 	name: relayerName,
			// 	apiURL: `${backendURL}/sra/3/v2/`,
			// },
			relayers: [
				// {
				// 	name: 'LedgerDex',
				// 	apiURL: `${backendURL}/sra/v2/`,
				// },
				// {
				// 	name: 'Mesh',
				// 	apiURL: 'https://kovan.api.0x.org/sra/',
				// 	// wsURL: 'wss://ws.radarrelay.com/0x/v2'
				// },
				{
					name: 'LedgerDex',
					apiURL: `${backendURL}/sra/3/v3/`,
					orderBookPriority: 10,
				}
			],
			// popularTradingPairs: popularTradingPairs[3]
		},
		42: {
			id: 42,
			name: 'Kovan Testnet',
			rpc: 'https://kovan.infura.io/v3/2dba9736d8f64eb6b639fe233fea428c',
			txURL: 'https://kovan.etherscan.io/tx/',
			accountURL: 'https://kovan.etherscan.io/address/',
			tokenURL: 'https://kovan.etherscan.io/token/',
			etherscanApiURL: 'https://api-kovan.etherscan.io/',
			feeRecipientAddress: '0x4524baa98f9a3b9dec57caae7633936ef96bd708',
			backendSRAHttpURL: `${backendURL}/sra/42/v3/`,
			meshSRAHttpURL: 'https://kovan.api.0x.org/sra/',
			gasPriceCheckerURL: {
				etherscan: 'https://api-kovan.etherscan.io/api?module=gastracker&action=gasoracle'
			},
			// ownRelayer: {
			// 	name: relayerName,
			// 	apiURL: `${backendURL}/sra/v2/`,
			// },
			relayers: [
				{
					name: 'LedgerDex',
					apiURL: `${backendURL}/sra/42/v3/`,
					orderBookPriority: 10,
				},
				// {
				// 	name: 'Radar Relay',
				// 	apiURL: 'https://api.kovan.radarrelay.com/0x/v3/',
				// 	// wsURL: 'wss://ws.kovan.radarrelay.com/0x/v2'
				// },
				{
					name: 'Mesh',
					apiURL: 'https://kovan.api.0x.org/sra/',
					orderBookPriority: 100,
					// wsURL: 'wss://ws.radarrelay.com/0x/v2'
				},

			],
			// popularTradingPairs: popularTradingPairs[42]
		}
	},
	defaultTokenList: [
		'WETH'
	],
	ZRXTokenDefault: {
		name: '0x Protocol Token',
		symbol: 'ZRX',
		decimals: 18,
	},
	WETHTokenDefault: {
		name: 'Wrapped Ether',
		symbol: 'WETH',
		decimals: 18,
	},
	ETHDecimals: 18,
	inputAmountMaxDecimals: 18,
	unlimitedAllowance: 999999999,
	defaultLocale: 'zh',
	multiLanguage: multiLanguage,
	i18n: [
		{
			langDisplay: '简体中文',
			locale: 'zh',
			aliases: ['zh', 'zh-cn', 'zh-hk', 'zh-sg', 'zh-tw'],
		},
		{
			langDisplay: 'English',
			locale: 'en',
			aliases: ['en', 'en-us', 'en-au', 'en-bz', 'en-ca', 'en-ie', 'en-jm', 'en-nz', 'en-ph', 'en-za', 'en-tt', 'en-gb', 'en-zw'],
		},
		// {
		//   langDisplay: '日本語',
		//   locale: 'jp',
		//   aliases: ['jp'],
		// },
	],
}
